import { render, staticRenderFns } from "./WorkflowPrepAuditTrailHistory.vue?vue&type=template&id=3c6e72dc"
import script from "./WorkflowPrepAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports